function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-4{isolation:isolate}.cls-2{fill:#eec1bb}.cls-3{fill:#c74368}.cls-4{opacity:.2}.cls-5{fill:#263238}.cls-6{fill:#2e353a}.cls-8{fill:#e4e4e4}.cls-9{opacity:.3}.cls-12{fill:#455a64}\n        "));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_2289",
  transform: "translate(0 15.643)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2286"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2268",
  transform: "translate(0 2.758)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1356",
  d: "M108.666 166.643l6.239-2.209-2.677-3.576a13.32 13.32 0 0 1-.192-2.393 3.627 3.627 0 0 1 .207-1.211 5.548 5.548 0 0 1 .65-1.387.475.475 0 0 0-.422-.793 3.9 3.9 0 0 0-1.626 2.574c-.372 1.472-1.38-.694-1.762-1.477s-1.676-3.15-2.01-3.224c-.489-.107-.695.4-.3 1.17s1.434 3.176 1.011 3.358-2.306-3.833-2.306-3.833-.265-.923-.761-.729c-.895.349 1.427 4.467 1.658 4.853.16.268-.292.482-.449.185s-1.791-4.046-2.7-3.7c-.7.266 1.878 3.4 1.785 4.368s-1.715-2.579-2.374-2.3c-.246.105-.414.217.811 2.117a31.647 31.647 0 0 0 1.966 2.567l3.255 5.636",
  className: "cls-2",
  transform: "translate(-102.461 -152.887)"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_2271",
  transform: "translate(6.205 9.075)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2270"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2269"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1357",
  d: "M172.786 182.443a114.92 114.92 0 0 0-5.2-10.674 7.465 7.465 0 0 0-6.059-3.918 9.7 9.7 0 0 0-1.8-.367l-11.544-.1a10.93 10.93 0 0 0-6.89 2.526c-.532.438-4.522 5.063-9.814 11.653l-9.261-10.007-5.521 3.265s6 20.7 13.521 19.282a18.738 18.738 0 0 0 7.945-3.947l5.859-4.722.136.782c.119.955.416 2.5.64 3.433.709 2.957 1.1 6.853-.419 9.434 0 0-2.088 1.6-.427 3.354h21.72s3.077-2.086.268-4.406l-1.76-4.407 1.138-5.376.426-2.153 1.91 3.276s3.785 4.761 7.719 4.175c4.73-.7 7.471-9.319 3.2-20.709l-5.142 1.564z",
  className: "cls-3",
  transform: "translate(-116.701 -167.383)"
})))), /*#__PURE__*/React.createElement("g", {
  id: "Group_2272",
  className: "cls-4",
  transform: "translate(6.205 13.25)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1358",
  d: "M116.7 180.229l.545 1.728 6.133-3.742-1.157-1.25z",
  transform: "translate(-116.701 -176.964)"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_2274",
  className: "cls-4",
  transform: "translate(33.652 27.748)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2273"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1359",
  d: "M179.921 223.265a6.863 6.863 0 0 0 4.574-2.817 7.151 7.151 0 0 0 1.3-5.333 2.373 2.373 0 0 0-.906-1.7c-.685-.429-1.62-.208-2.333-.588a4.709 4.709 0 0 1-1.3-1.469c-.4-.522-.967-1.335-1.571-1.071 0 0 .729 3.835 1.048 5.542a13.072 13.072 0 0 1-.177 5.953 7.718 7.718 0 0 1-.635 1.483z",
  transform: "translate(-179.687 -210.236)"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_2276",
  transform: "translate(20.096 23.256)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2275"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1360",
  d: "M148.6 203.464a5.335 5.335 0 0 1 .322-1.8 10.73 10.73 0 0 1 .549-1.736 5.361 5.361 0 0 1-.322 1.8 10.8 10.8 0 0 1-.549 1.736z",
  className: "cls-5",
  transform: "translate(-148.579 -199.928)"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_2278",
  transform: "translate(20.944 23.252)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2277"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1361",
  d: "M151.07 202.5a7.411 7.411 0 0 1-.521-2.584 7.421 7.421 0 0 1 .521 2.584z",
  className: "cls-5",
  transform: "translate(-150.525 -199.918)"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_2279",
  transform: "translate(55.027 .471)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1362",
  d: "M236.625 147.638l-7.886 12.779 6.206 1.726 6.884-10.617z",
  className: "cls-6",
  transform: "translate(-228.74 -147.638)"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_2280",
  transform: "translate(59.324 3.833)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1363",
  d: "M241.7 162.879l.27 1.868 1.1 1.416.111 1.16 3.956-1.2-1.6-5.645a11.641 11.641 0 0 0 .154-2.311l-1.086 1.444-.3-2.354-2.231-1.793a.541.541 0 0 0-.761.117.541.541 0 0 0 .059.7l1.79 1.578.116 1.949-1.294-1.2a.939.939 0 0 0-.457-.234l-1.8-.36a.469.469 0 0 0-.559.413.47.47 0 0 0 .329.5l1.636.5 1.656 1.671-1.618-.617-2.2.308a.427.427 0 0 0-.367.422.427.427 0 0 0 .45.426l1.4-.078.821.257-1.892.5a.382.382 0 0 0-.284.388.382.382 0 0 0 .414.362z",
  className: "cls-2",
  transform: "translate(-238.602 -155.354)"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_2281",
  className: "cls-4",
  transform: "translate(62.77 14.53)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1364",
  d: "M246.678 181.466l-.169 2.093 6-1.655-.689-2z",
  transform: "translate(-246.509 -179.902)"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_2282",
  transform: "translate(54.536)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1365",
  fill: "#222",
  d: "M228.1 159.808s-.529-.72-.488-.842 7.505-12.407 7.505-12.407l.869.471z",
  transform: "translate(-227.613 -146.558)"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_2283",
  transform: "translate(64.816 3.613)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1366",
  d: "M251.276 154.919a.273.273 0 1 1-.015.017",
  className: "cls-5",
  transform: "translate(-251.205 -154.849)"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_2285",
  transform: "translate(26.168 17.242)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2284"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1367",
  d: "M196.294 188.334a1.075 1.075 0 0 1-.227.307 2 2 0 0 1-.97.5 4.312 4.312 0 0 1-1.732 0 5.958 5.958 0 0 0-2.235-.1 6.1 6.1 0 0 0-2.36 1.314 8.843 8.843 0 0 1-2.71 1.687 4.436 4.436 0 0 1-1.744.137 7.555 7.555 0 0 1-1.748-.485c-1.143-.449-2.24-1.08-3.44-1.517a6.892 6.892 0 0 0-1.826-.405 6.79 6.79 0 0 0-1.813.153c-1.18.244-2.286.655-3.39.889a8.565 8.565 0 0 1-5.827-.806 8.733 8.733 0 0 1-3.032-2.6 6.146 6.146 0 0 1-.726-1.279c.028-.015.237.471.8 1.224a8.918 8.918 0 0 0 3.035 2.511 8.452 8.452 0 0 0 5.7.742c1.083-.234 2.186-.65 3.39-.9a6.988 6.988 0 0 1 1.873-.161 7.085 7.085 0 0 1 1.891.418c1.227.447 2.325 1.081 3.446 1.524a7.389 7.389 0 0 0 1.692.476 4.232 4.232 0 0 0 1.653-.122 8.759 8.759 0 0 0 2.652-1.633 6.226 6.226 0 0 1 2.445-1.323 5.984 5.984 0 0 1 2.291.133 4.317 4.317 0 0 0 1.69.042 2.036 2.036 0 0 0 .957-.449c.187-.169.254-.285.265-.277z",
  className: "cls-8",
  transform: "translate(-162.514 -186.125)"
})))), /*#__PURE__*/React.createElement("g", {
  id: "Group_2288",
  transform: "translate(62.224 23.878)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2287"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1368",
  d: "M245.448 205.228a15.972 15.972 0 0 1-.121-3.873 15.978 15.978 0 0 1 .121 3.873z",
  className: "cls-5",
  transform: "translate(-245.255 -201.355)"
}))));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Group_2376",
  transform: "translate(48.824 123.238)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2290"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1369",
  d: "M214.506 393.75c.191.756 4.635 25.678 4.635 25.678l6.808-.509-1.249-25.448z",
  className: "cls-2",
  transform: "translate(-214.506 -393.471)"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_2375",
  transform: "translate(4.311 25.126)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2374"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2299",
  transform: "translate(.062)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2294"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2293"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2292"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2291"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1370",
  d: "M231.817 451.847l-.021-.716-7.256.151.044 2.362.448.018c2 .065 10.152.2 11.476-.2 1.476-.445-4.691-1.615-4.691-1.615z",
  className: "cls-3",
  transform: "translate(-224.54 -451.131)"
}))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_2298",
  className: "cls-9",
  transform: "translate(.007 .53)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2297"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2296"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2295"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1371",
  d: "M227.211 454.228a2.321 2.321 0 0 0-.955-1.414 2.57 2.57 0 0 0-1.7-.457l.042 1.877z",
  transform: "translate(-224.556 -452.346)"
})))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_2303",
  transform: "translate(.105 1.387)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2302"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2301",
  className: "cls-9"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2300"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1372",
  d: "M234.889 454.315s2.164.536 1.9.871-8.508.485-12.153.255l.008-.15 9.622-.1s.203-.852.623-.876z",
  transform: "translate(-224.64 -454.315)"
}))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_2308",
  transform: "translate(0 2.144)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2307"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2306"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2305"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2304"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1373",
  d: "M224.4 456.268a.674.674 0 0 0 .125.01l.357.014 1.314.028c1.11.017 2.643.021 4.336-.008s3.226-.088 4.334-.144l1.312-.075.356-.026a.691.691 0 0 0 .124-.015.785.785 0 0 0-.125 0l-.357.011-1.313.049c-1.109.041-2.64.09-4.333.12s-3.225.034-4.334.032h-1.671a.758.758 0 0 0-.125.004z",
  className: "cls-5",
  transform: "translate(-224.398 -456.05)"
})))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_2313",
  transform: "translate(9.722 1.304)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2312"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2311"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2310"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2309"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1374",
  d: "M246.722 455.188a2.611 2.611 0 0 1 .232-.587 2.837 2.837 0 0 1 .437-.475.958.958 0 0 0-.512.434.847.847 0 0 0-.157.628z",
  className: "cls-5",
  transform: "translate(-246.708 -454.123)"
})))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_2318",
  transform: "translate(7.578 .835)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2317"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2316"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2315"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2314"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1375",
  d: "M241.793 453.615c.02.012.12-.105.222-.262s.168-.292.147-.3-.12.105-.222.261-.168.286-.147.301z",
  className: "cls-5",
  transform: "translate(-241.789 -453.048)"
})))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_2323",
  transform: "translate(6.989 .738)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2322"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2321"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2320"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2319"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1376",
  d: "M240.438 453.212c.017.016.129-.057.251-.163s.207-.206.191-.222-.129.056-.251.163-.207.21-.191.222z",
  className: "cls-5",
  transform: "translate(-240.436 -452.825)"
})))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_2328",
  transform: "translate(6.607 .454)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2327"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2326"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2325"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2324"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1377",
  d: "M239.56 452.217a.914.914 0 0 0 .378.037.9.9 0 0 0 .377-.044.917.917 0 0 0-.378-.037.9.9 0 0 0-.377.044z",
  className: "cls-5",
  transform: "translate(-239.56 -452.174)"
})))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_2333",
  transform: "translate(6.469 .046)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2332"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2331"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2330"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2329"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1378",
  d: "M239.245 451.244a.773.773 0 0 0 .423.106.782.782 0 0 0 .433-.062 2.516 2.516 0 0 0-.428-.02 2.476 2.476 0 0 0-.428-.024z",
  className: "cls-5",
  transform: "translate(-239.245 -451.236)"
})))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_2338",
  transform: "translate(7.814 .191)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2337"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2336"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2335"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2334"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1379",
  d: "M242.33 452.19a1.449 1.449 0 0 0 .464-.011 2.912 2.912 0 0 0 .492-.11 1.417 1.417 0 0 0 .281-.114.237.237 0 0 0 .112-.136.164.164 0 0 0-.074-.171.889.889 0 0 0-1.048.251.753.753 0 0 0-.145.291c-.017.074-.014.116-.009.117a1.179 1.179 0 0 1 .2-.372.84.84 0 0 1 .391-.247.769.769 0 0 1 .554.025c.075.049.048.13-.033.177a1.429 1.429 0 0 1-.258.108 3.385 3.385 0 0 1-.475.125c-.276.05-.452.054-.452.067z",
  className: "cls-5",
  transform: "translate(-242.33 -451.569)"
})))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_2343",
  transform: "translate(7.314 .004)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2342"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2341"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2340"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2339"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1380",
  d: "M241.8 451.967a.4.4 0 0 0 .047-.3.676.676 0 0 0-.134-.313.472.472 0 0 0-.391-.213.171.171 0 0 0-.139.2.459.459 0 0 0 .083.191 1.321 1.321 0 0 0 .225.257.674.674 0 0 0 .269.17c.008-.011-.094-.076-.225-.21a1.54 1.54 0 0 1-.2-.255c-.066-.09-.113-.253 0-.275a.422.422 0 0 1 .31.178.686.686 0 0 1 .137.278 1.477 1.477 0 0 1 .018.292z",
  className: "cls-5",
  transform: "translate(-241.182 -451.139)"
})))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_2348",
  transform: "translate(.107 .468)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2347"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2346"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2345"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2344"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1381",
  d: "M224.643 452.258c0 .015.206-.022.534.008a2.44 2.44 0 0 1 1.174.425 2.183 2.183 0 0 1 .749.943c.117.286.132.479.148.477a.371.371 0 0 0 0-.135 1.647 1.647 0 0 0-.087-.361 2.085 2.085 0 0 0-.754-.988 2.343 2.343 0 0 0-1.223-.418 2.076 2.076 0 0 0-.4.017.442.442 0 0 0-.141.032z",
  className: "cls-5",
  transform: "translate(-224.643 -452.206)"
})))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_2353",
  transform: "translate(3.618 1.712)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2352"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2351"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2350"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2349"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1382",
  d: "M232.7 455.088a6.361 6.361 0 0 0 2.111-.02c0-.024-.474.012-1.055.017s-1.056-.02-1.056.003z",
  className: "cls-5",
  transform: "translate(-232.7 -455.061)"
})))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_2358",
  transform: "translate(2.199 1.761)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2357"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2356"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2355"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2354"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1383",
  d: "M229.447 455.175c-.017.017.041.092.091.192s.079.188.1.187.035-.107-.024-.222-.152-.173-.167-.157z",
  className: "cls-5",
  transform: "translate(-229.444 -455.173)"
})))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_2363",
  transform: "translate(1.651 1.153)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2362"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2361"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2360"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2359"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1384",
  d: "M228.191 453.781c-.017.016.031.085.108.154s.152.112.169.1-.031-.085-.108-.154-.152-.117-.169-.1z",
  className: "cls-5",
  transform: "translate(-228.187 -453.777)"
})))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_2368",
  transform: "translate(.885 .848)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2367"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2366"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2365"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2364"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1385",
  d: "M226.428 453.117c.006.023.1.02.208.053s.184.084.2.068-.044-.107-.177-.146-.238.008-.231.025z",
  className: "cls-5",
  transform: "translate(-226.428 -453.076)"
})))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_2373",
  transform: "translate(.338 .749)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2372"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2371"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2370"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2369"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1386",
  d: "M225.174 452.866c-.008.021.034.054.094.075s.116.02.125 0-.034-.055-.095-.075-.116-.022-.124 0z",
  className: "cls-5",
  transform: "translate(-225.173 -452.849)"
})))))))));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "Group_2463",
  transform: "translate(28.083 121.437)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2377",
  transform: "translate(.553)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1387",
  d: "M171.043 389.338c-.035.779-2.866 25.05-2.866 25.05l6.666 1.476 6.147-24.725z",
  className: "cls-2",
  transform: "translate(-168.177 -389.338)"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_2462",
  transform: "translate(0 24.891)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2461"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2386",
  transform: "translate(.066)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2381"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2380"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2379"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2378"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1388",
  d: "M174.513 448.741l.15-.7-7.083-1.58-.52 2.3.431.125c1.923.539 9.812 2.613 11.193 2.539 1.541-.08-4.171-2.684-4.171-2.684z",
  className: "cls-3",
  transform: "translate(-167.06 -446.459)"
}))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_2385",
  className: "cls-9",
  transform: "translate(.028 .38)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2384"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2383"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2382"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1389",
  d: "M169.663 449.78a2.318 2.318 0 0 0-.59-1.6 2.57 2.57 0 0 0-1.542-.848l-.406 1.833z",
  transform: "translate(-167.124 -447.331)"
})))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_2390",
  transform: "translate(.066 2.161)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2389"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2388",
  className: "cls-9"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2387"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1390",
  d: "M177.282 452.908s1.974 1.036 1.641 1.3-8.379-1.555-11.864-2.645l.044-.144 9.369 2.194s.396-.781.81-.705z",
  transform: "translate(-167.06 -451.418)"
}))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_2395",
  transform: "translate(0 2.131)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2394"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2393"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2392"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2391"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1391",
  d: "M166.908 451.35a.736.736 0 0 0 .119.04l.343.1 1.27.341c1.074.281 2.562.65 4.213 1.024s3.154.682 4.244.892l1.292.24.352.06a.748.748 0 0 0 .124.015.673.673 0 0 0-.121-.031l-.349-.075-1.287-.265c-1.086-.224-2.586-.541-4.237-.915s-3.14-.734-4.217-1l-1.275-.315-.348-.083a.734.734 0 0 0-.123-.028z",
  className: "cls-5",
  transform: "translate(-166.908 -451.35)"
})))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_2400",
  transform: "translate(9.45 3.58)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2399"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2398"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2397"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2396"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1392",
  d: "M188.6 455.551a2.636 2.636 0 0 1 .365-.515 2.844 2.844 0 0 1 .538-.358.957.957 0 0 0-.6.3.85.85 0 0 0-.303.573z",
  className: "cls-5",
  transform: "translate(-188.593 -454.674)"
})))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_2405",
  transform: "translate(7.59 2.542)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2404"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2403"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2402"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2401"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1393",
  d: "M184.328 452.755c.017.016.142-.074.278-.2s.233-.244.215-.26-.142.074-.278.2-.232.244-.215.26z",
  className: "cls-5",
  transform: "translate(-184.326 -452.291)"
})))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_2410",
  transform: "translate(7.083 2.322)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2409"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2408"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2407"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2406"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1394",
  d: "M183.163 452.061c.012.02.139-.024.283-.1s.251-.15.238-.17-.139.024-.282.1-.251.15-.239.17z",
  className: "cls-5",
  transform: "translate(-183.162 -451.788)"
})))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_2415",
  transform: "translate(6.86 1.886)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2414"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2413"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2412"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2411"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1395",
  d: "M182.651 450.8a.9.9 0 0 0 .358.127.191.191 0 1 0-.358-.127z",
  className: "cls-5",
  transform: "translate(-182.651 -450.787)"
})))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_2420",
  transform: "translate(6.833 1.427)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2419"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2418"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2417"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2416"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1396",
  d: "M182.588 449.738a1.136 1.136 0 0 0 .821.247 2.477 2.477 0 0 0-.411-.121 2.435 2.435 0 0 0-.41-.126z",
  className: "cls-5",
  transform: "translate(-182.588 -449.734)"
})))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_2425",
  transform: "translate(7.958 2.078)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2424"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2423"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2422"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2421"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1397",
  d: "M185.171 451.637a1.437 1.437 0 0 0 .453.1 2.934 2.934 0 0 0 .5.01 1.425 1.425 0 0 0 .3-.044.238.238 0 0 0 .141-.105.166.166 0 0 0-.031-.184.889.889 0 0 0-1.077-.006.745.745 0 0 0-.21.248c-.034.068-.042.109-.037.111a1.189 1.189 0 0 1 .286-.313.844.844 0 0 1 .439-.147.77.77 0 0 1 .532.156c.061.066.016.139-.074.165a1.448 1.448 0 0 1-.277.044 3.441 3.441 0 0 1-.491.008c-.279-.017-.451-.056-.454-.043z",
  className: "cls-5",
  transform: "translate(-185.171 -451.228)"
})))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_2430",
  transform: "translate(7.618 1.617)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2429"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2428"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2427"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2426"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1398",
  d: "M184.843 451.087a.4.4 0 0 0 .117-.281.676.676 0 0 0-.056-.336.473.473 0 0 0-.329-.3.172.172 0 0 0-.183.163.456.456 0 0 0 .035.205 1.349 1.349 0 0 0 .157.3.684.684 0 0 0 .221.229c.01-.008-.073-.1-.169-.258a1.528 1.528 0 0 1-.134-.3c-.042-.1-.049-.273.068-.266s.208.146.259.246a.688.688 0 0 1 .067.3 1.438 1.438 0 0 1-.053.298z",
  className: "cls-5",
  transform: "translate(-184.391 -450.169)"
})))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_2435",
  transform: "translate(.541 .366)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2434"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2433"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2432"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2431"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1399",
  d: "M168.15 447.3c0 .015.206.027.517.134a2.448 2.448 0 0 1 1.039.692 2.188 2.188 0 0 1 .5 1.094c.045.305.013.5.03.5a.363.363 0 0 0 .03-.132 1.685 1.685 0 0 0 0-.371 2.085 2.085 0 0 0-.5-1.139 2.341 2.341 0 0 0-1.088-.7 2.034 2.034 0 0 0-.39-.078.428.428 0 0 0-.138 0z",
  className: "cls-5",
  transform: "translate(-168.15 -447.298)"
})))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_2440",
  transform: "translate(3.661 2.387)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2439"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2438"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2437"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2436"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1400",
  d: "M175.31 451.94a6.353 6.353 0 0 0 2.055.483c0-.024-.463-.1-1.029-.235s-1.018-.27-1.026-.248z",
  className: "cls-5",
  transform: "translate(-175.31 -451.938)"
})))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_2445",
  transform: "translate(2.275 2.075)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2444"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2443"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2442"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2441"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1401",
  d: "M172.134 451.221c-.021.012.017.1.043.208s.032.2.056.206.059-.1.029-.221-.109-.205-.128-.193z",
  className: "cls-5",
  transform: "translate(-172.128 -451.22)"
})))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_2450",
  transform: "translate(1.887 1.354)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2449"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2448"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2447"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2446"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1402",
  d: "M171.246 449.568c-.02.011.01.09.068.175s.121.145.141.133-.01-.09-.068-.175-.121-.145-.141-.133z",
  className: "cls-5",
  transform: "translate(-171.239 -449.567)"
})))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_2455",
  transform: "translate(1.21 .893)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2454"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2453"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2452"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2451"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1403",
  d: "M169.684 448.527c0 .024.094.044.19.1s.159.126.181.115-.017-.115-.137-.184-.236-.053-.234-.031z",
  className: "cls-5",
  transform: "translate(-169.684 -448.508)"
})))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_2460",
  transform: "translate(.706 .654)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2459"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2458"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2457"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2456"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1404",
  d: "M168.53 447.967c-.013.019.02.061.074.1s.108.047.121.029-.02-.061-.074-.1-.108-.047-.121-.029z",
  className: "cls-5",
  transform: "translate(-168.527 -447.959)"
})))))))));

var _ref6 = /*#__PURE__*/React.createElement("g", {
  id: "Group_2464",
  transform: "translate(0 .04)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1405",
  d: "M191.984 115.654a1.14 1.14 0 0 1-.075 1.094.717.717 0 0 1-.846.272.591.591 0 0 1-.309-.662.419.419 0 0 1 .476-.268.472.472 0 0 1 .338.188c.05.078.054.132.067.131s.02-.057-.021-.156a.5.5 0 0 0-.367-.262.617.617 0 0 0-.339.024.488.488 0 0 0-.291.3.746.746 0 0 0 .361.872.908.908 0 0 0 1.1-.3 1.354 1.354 0 0 0 .129-1.311 2.16 2.16 0 0 0-2.292-1.3 1.433 1.433 0 0 0 .133-1.158 1.629 1.629 0 0 0-1.005-1.009 2.151 2.151 0 0 0-1.277-.069 3.192 3.192 0 0 0-1.007.445c-.282.184-.5.387-.712.522a1.275 1.275 0 0 1-.588.226.987.987 0 0 1-.528-.109c-.016 0 .136.21.533.209a1.318 1.318 0 0 0 .658-.2c.234-.133.461-.327.734-.491a2.39 2.39 0 0 1 2.1-.309 1.4 1.4 0 0 1 .849.861 1.126 1.126 0 0 1-.3 1.163 2.558 2.558 0 0 0-.943-.967 1.921 1.921 0 0 0-2.6.644l-7.15-2.454a3.485 3.485 0 0 0-3.284-.661c-.049-.009-.1-.018-.15-.024a2.319 2.319 0 0 0-1.207.2 3.955 3.955 0 0 0-1.216 1.062 2.65 2.65 0 0 1-.686.568 1.254 1.254 0 0 1-.137.057 6.609 6.609 0 0 1-.955.033 14.223 14.223 0 0 0-1.965-.559 3.1 3.1 0 0 0-1.24.089 2.373 2.373 0 0 0-1.105.7 1.909 1.909 0 0 0-.478 1.272 3.492 3.492 0 0 0 .156.989 3.428 3.428 0 0 0-.21 1.35c.032.605.206 1.239.213 1.836a1.711 1.711 0 0 1-.585.3c-.377.119-.781.176-1.164.323a2.7 2.7 0 0 0-1.545 1.635 1.91 1.91 0 0 0 .193 1.8 2.749 2.749 0 0 0 .5 2.307 14.087 14.087 0 0 1 1.121 1.2 6.053 6.053 0 0 1 .521 2.525c.119.86.617 1.831 1.483 1.888.7.046 1.325-.54 2.022-.483.978.081 1.378 1.252 1.944 2.054a3.484 3.484 0 0 0 3.245 1.413c.889-.121 1.77-.591 2.64-.37 1.094.278 1.75 1.56 2.868 1.72a2.889 2.889 0 0 0 2.218-1 4.481 4.481 0 0 1 2.072-1.368c.995-.179 1.953.423 2.954.56a3.339 3.339 0 0 0 3.292-1.652c.551-1 .549-2.222 1.063-3.238a18.165 18.165 0 0 1 1.328-1.861 2.505 2.505 0 0 0 .479-2.153c-.181-.518-.619-.908-.832-1.414a4.93 4.93 0 0 1 0-2.431 2.027 2.027 0 0 0-.832-2.144 7.7 7.7 0 0 1-.959-.319c-.582-.362-.551-1.194-.6-1.877a3.77 3.77 0 0 0-.342-1.3l.122-.038m-25.228 6.306a.591.591 0 0 0-.246-.012 1.638 1.638 0 0 0 .2.049c-.045.032-.091.063-.134.1a2.638 2.638 0 0 0-.844 1.3 1.847 1.847 0 0 1-.044-1.482 2.489 2.489 0 0 1 1.427-1.482c.35-.133.747-.187 1.153-.31a2.028 2.028 0 0 0 .5-.221 1.744 1.744 0 0 1-.206.675c-.377.645-1.171.92-1.803 1.364zm4.88-8.017a3.765 3.765 0 0 0-2.694 2.062 2.764 2.764 0 0 1-.068-.6 1.652 1.652 0 0 1 .412-1.108 2.4 2.4 0 0 1 2.126-.717 4.832 4.832 0 0 1 1.173.3 5.581 5.581 0 0 0-.946.045zm3.586-.3a2.433 2.433 0 0 1-.268.1 4.087 4.087 0 0 0 .364-.363 3.905 3.905 0 0 1 1.143-1.055 2.245 2.245 0 0 1 1.056-.23 3.133 3.133 0 0 0-.538.27 15.834 15.834 0 0 1-1.749 1.257z",
  className: "cls-6",
  transform: "translate(-163.121 -110.752)"
}));

var _ref7 = /*#__PURE__*/React.createElement("g", {
  id: "Group_2465"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1406",
  d: "M202.207 132.6a46.105 46.105 0 0 0 .052-8.545 4.559 4.559 0 0 0-5.028-4.25l-7.49.792a1.519 1.519 0 0 0-1.358 1.54l.772 18.4h-1.732v3.332a6.9 6.9 0 1 0 13.8 0v-2.883a10.5 10.5 0 0 0-2.883-.526c-.062 0-.155.007-.268.01.007-1.687.138-3.007.138-3.007s3.312-.543 3.997-4.863z",
  className: "cls-2",
  transform: "translate(-187.422 -119.782)"
}));

var _ref8 = /*#__PURE__*/React.createElement("g", {
  id: "Group_2475",
  transform: "translate(11.885 5.525)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2469",
  transform: "translate(.725 1.045)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2468"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2467"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2466"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1407",
  d: "M217.466 135.36a.554.554 0 0 1-.534.559.53.53 0 0 1-.571-.5.554.554 0 0 1 .533-.559.53.53 0 0 1 .572.5z",
  className: "cls-6",
  transform: "translate(-216.361 -134.86)"
}))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_2474"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2473"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2472"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2471"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2470"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1408",
  d: "M216.885 133.044c-.069.072-.488-.238-1.084-.237s-1.032.3-1.1.227c-.032-.032.038-.163.228-.3a1.517 1.517 0 0 1 .878-.271 1.456 1.456 0 0 1 .863.278c.187.14.249.27.215.303z",
  className: "cls-6",
  transform: "translate(-214.697 -132.462)"
})))))));

var _ref9 = /*#__PURE__*/React.createElement("g", {
  id: "Group_2485",
  transform: "translate(6.028 5.636)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2479",
  transform: "translate(.758 .934)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2478"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2477"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2476"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1409",
  d: "M204.1 135.36a.554.554 0 0 1-.534.559.53.53 0 0 1-.571-.5.554.554 0 0 1 .533-.559.53.53 0 0 1 .572.5z",
  className: "cls-6",
  transform: "translate(-202.995 -134.86)"
}))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_2484"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2483"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2482"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2481"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2480"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1410",
  d: "M203.445 133.3c-.069.072-.489-.238-1.084-.236s-1.032.3-1.1.226c-.031-.032.038-.163.229-.3a1.517 1.517 0 0 1 .878-.271 1.46 1.46 0 0 1 .863.278c.185.139.248.269.214.303z",
  className: "cls-6",
  transform: "translate(-201.256 -132.717)"
})))))));

var _ref10 = /*#__PURE__*/React.createElement("g", {
  id: "Group_2490",
  transform: "translate(10.1 5.673)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2489"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2488"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2487"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2486"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1411",
  d: "M210.88 137.764a3.968 3.968 0 0 1 .968-.174c.152-.016.3-.046.322-.15a.776.776 0 0 0-.1-.451l-.45-1.158a19.945 19.945 0 0 1-1.01-3.03 19.926 19.926 0 0 1 1.252 2.942l.431 1.165a.881.881 0 0 1 .079.6.382.382 0 0 1-.25.223 1.03 1.03 0 0 1-.258.036 3.857 3.857 0 0 1-.984-.003z",
  className: "cls-6",
  transform: "translate(-210.601 -132.8)"
}))))));

var _ref11 = /*#__PURE__*/React.createElement("g", {
  id: "Group_2498",
  transform: "translate(8.35 11.668)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2497"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2496"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2495"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1413",
  fill: "#d4827d",
  d: "M208.361 146.963a1.073 1.073 0 0 0-.963-.4.977.977 0 0 0-.677.363.621.621 0 0 0-.048.71.721.721 0 0 0 .781.2 2.255 2.255 0 0 0 .761-.454.656.656 0 0 0 .17-.176.2.2 0 0 0 0-.222",
  transform: "translate(-206.584 -146.558)"
})))));

var _ref12 = /*#__PURE__*/React.createElement("g", {
  id: "Group_2503",
  transform: "translate(8.529 11.049)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2502"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2501"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2500"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2499"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1414",
  d: "M207.092 145.138c.1-.006.1.641.652 1.1s1.242.388 1.247.478c.009.041-.153.126-.444.134a1.611 1.611 0 0 1-1.041-.363 1.4 1.4 0 0 1-.5-.922c-.03-.271.042-.431.086-.427z",
  className: "cls-6",
  transform: "translate(-206.995 -145.138)"
}))))));

var _ref13 = /*#__PURE__*/React.createElement("g", {
  id: "Group_2510",
  transform: "translate(5.766 4.729)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2509"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2508"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2507"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1415",
  d: "M203.373 131.08c-.059.162-.654.085-1.353.17s-1.265.275-1.357.129c-.041-.07.057-.222.285-.379a2.366 2.366 0 0 1 2.064-.228c.257.104.388.228.361.308z",
  className: "cls-6",
  transform: "translate(-200.654 -130.633)"
})))));

var _ref14 = /*#__PURE__*/React.createElement("g", {
  id: "Group_2514",
  transform: "translate(11.826 4.273)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2513"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2512"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2511"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1416",
  d: "M216.589 130.2c-.105.135-.515-.005-1.009-.012-.493-.024-.912.091-1.008-.051-.042-.069.024-.2.207-.332a1.46 1.46 0 0 1 1.624.05c.175.145.232.283.186.345z",
  className: "cls-6",
  transform: "translate(-214.56 -129.587)"
})))));

var _ref15 = /*#__PURE__*/React.createElement("g", {
  id: "Group_2518"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1417",
  d: "M203.15 115.058a3.209 3.209 0 0 0-2.334-2.432 19.7 19.7 0 0 0-2.316.035c-.637-.041-.869-.549-1.476-.748-1.012-.332-1.788-1.456-3.971-1.221a3.366 3.366 0 0 0-1.867 1.507 3.489 3.489 0 0 0-2.542.291 4.427 4.427 0 0 0-2.277 3.381 14.119 14.119 0 0 0 .156 4.335q.139.984.276 1.969a3.467 3.467 0 0 0 .348 1.255l-.994 9.242a3.844 3.844 0 0 0 4.886-2.685c.386-1.817-.625-3.668-.465-5.518.1-1.1.718-2.128.714-3.233a4.263 4.263 0 0 0-.154-1.076c1.757-1.425 2.2-2.572 2.13-3.907a3.356 3.356 0 0 0 1.828.605c.925.011 1.886-.347 2.751-.021a4.818 4.818 0 0 1 1.539 1.249 2.219 2.219 0 0 0 1.749.808 4.585 4.585 0 0 0 .907-.319 1.1 1.1 0 0 1 .932 0 7.216 7.216 0 0 0 .18-3.517z",
  className: "cls-6",
  transform: "translate(-186.153 -110.66)"
}));

var _ref16 = /*#__PURE__*/React.createElement("g", {
  id: "Group_2532",
  transform: "translate(23.136 59.484)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2521"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1418",
  d: "M155.554 310.095s2.912 5.662 10.515 2.912c0 0 7.441 4.044 14.56-.485 0 0 9.218 1.236 14.233-1.19l-6.45-55.622-.817-8.543h-20.337s-6.042 2.75-7.013 16.177-3.074 31.869-3.074 31.869z",
  className: "cls-6",
  transform: "translate(-155.554 -247.166)"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_2523",
  transform: "translate(22.896 .205)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2522"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1419",
  d: "M209.844 312.958a.9.9 0 0 1-.023-.167l-.044-.494-.147-1.9c-.126-1.649-.284-4.037-.459-6.99-.351-5.9-.728-14.068-.926-23.09s-.172-17.2-.077-23.113c.047-2.957.1-5.349.156-7l.064-1.9.023-.5a.085.085 0 1 1 .024 0v.5l-.022 1.9-.083 7c-.054 5.913-.051 14.083.143 23.106s.549 17.182.858 23.087l.387 6.992c.045.816.08 1.454.1 1.9l.022.5a.937.937 0 0 1 .004.169z",
  className: "cls-12",
  transform: "translate(-208.098 -247.637)"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_2525",
  transform: "translate(25.936 49.508)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2524"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1420",
  d: "M215.563 360.886c-.005-.01.043-.059.159-.089a.742.742 0 0 1 .5.063.842.842 0 0 1 .468.588.844.844 0 0 1-1.342.763.845.845 0 0 1-.266-.7.741.741 0 0 1 .2-.457c.085-.084.152-.1.158-.091a1.046 1.046 0 0 0-.2.555.709.709 0 0 0 .24.536.65.65 0 0 0 1-.569.707.707 0 0 0-.338-.48 1.041 1.041 0 0 0-.579-.119z",
  className: "cls-12",
  transform: "translate(-215.074 -360.778)"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_2527",
  transform: "translate(25.485 32.981)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2526"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1421",
  d: "M214.527 322.96c-.006-.01.043-.058.159-.089a.742.742 0 0 1 .5.063.846.846 0 0 1 .468.588.844.844 0 0 1-1.342.763.845.845 0 0 1-.266-.7.742.742 0 0 1 .2-.457c.085-.084.152-.1.158-.091a1.033 1.033 0 0 0-.2.554.71.71 0 0 0 .24.536.651.651 0 0 0 1-.57.708.708 0 0 0-.338-.48 1.041 1.041 0 0 0-.579-.117z",
  className: "cls-12",
  transform: "translate(-214.038 -322.852)"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_2529",
  transform: "translate(25.22 18.375)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2528"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1422",
  d: "M213.918 289.441c-.005-.01.043-.059.159-.089a.744.744 0 0 1 .5.062.844.844 0 0 1 .468.588.844.844 0 0 1-1.342.763.845.845 0 0 1-.266-.7.744.744 0 0 1 .2-.458c.086-.084.152-.1.158-.091a1.042 1.042 0 0 0-.2.555.71.71 0 0 0 .24.536.651.651 0 0 0 1-.569.709.709 0 0 0-.338-.481 1.039 1.039 0 0 0-.579-.116z",
  className: "cls-12",
  transform: "translate(-213.429 -289.333)"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_2531",
  transform: "translate(24.699 2.747)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2530"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1423",
  d: "M212.724 253.577c-.006-.01.043-.059.159-.09a.745.745 0 0 1 .5.063.846.846 0 0 1 .468.588.844.844 0 0 1-1.342.763.845.845 0 0 1-.266-.7.744.744 0 0 1 .2-.457c.085-.084.152-.1.158-.091a1.04 1.04 0 0 0-.2.555.709.709 0 0 0 .24.536.651.651 0 0 0 1-.569.71.71 0 0 0-.338-.481 1.039 1.039 0 0 0-.579-.117z",
  className: "cls-12",
  transform: "translate(-212.235 -253.469)"
}))));

var _ref17 = /*#__PURE__*/React.createElement("g", {
  id: "Group_2536",
  transform: "translate(.001 39.858)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2535"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2534"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1424",
  d: "M273.225 213.935l102.783-.747 2.865 69.879-106.427-.987z",
  className: "cls-3",
  transform: "translate(-272.445 -213.189)"
}))));

var _ref18 = /*#__PURE__*/React.createElement("g", {
  id: "Group_2539",
  transform: "translate(.781)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2538"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2537"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1425",
  d: "M274.235 162.325l48.644-39.361a5.586 5.586 0 0 1 7.056.022l47.082 38.592",
  className: "cls-3",
  transform: "translate(-274.235 -121.72)"
}))));

var _ref19 = /*#__PURE__*/React.createElement("g", {
  id: "Group_2541"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2540"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1426",
  d: "M274.235 162.325l48.644-39.361a5.586 5.586 0 0 1 7.056.022l47.082 38.592",
  transform: "translate(-274.235 -121.72)"
})));

var _ref20 = /*#__PURE__*/React.createElement("g", {
  id: "Group_2546",
  transform: "translate(0 69.055)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2545"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2544"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2543"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1427",
  d: "M272.443 319.887c-.128-.12 8.1-9.1 18.376-20.064s18.714-19.751 18.843-19.63-8.1 9.1-18.379 20.066-18.712 19.748-18.84 19.628z",
  className: "cls-5",
  transform: "translate(-272.442 -280.191)"
})))));

var _ref21 = /*#__PURE__*/React.createElement("g", {
  id: "Group_2550",
  transform: "translate(71.109 69.994)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2549"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2548"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2547"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1428",
  d: "M470.946 322.09c-.132.117-8.145-8.686-17.9-19.658s-17.553-19.967-17.422-20.084 8.143 8.684 17.9 19.661 17.553 19.964 17.422 20.081z",
  className: "cls-5",
  transform: "translate(-435.626 -282.346)"
})))));

var _ref22 = /*#__PURE__*/React.createElement("g", {
  id: "Group_2553",
  opacity: 0.5,
  transform: "translate(.781 39.858)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2552"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2551"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1429",
  d: "M377.018 213.189l-51.612 41.231-51.171-40.484",
  transform: "translate(-274.235 -213.189)"
}))));

var _ref23 = /*#__PURE__*/React.createElement("g", {
  id: "Group_2560",
  transform: "translate(5.724 11.143)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2559"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2558"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2555",
  transform: "translate(.073 .114)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1430",
  d: "M285.906 180.72l-.16-32.1 90-1.064 1.014 33.776-44.86 35.514z",
  className: "cls-3",
  transform: "translate(-285.745 -147.554)"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_2557"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2556"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1431",
  d: "M285.811 180.572s.291.218.844.647l2.442 1.9 9.287 7.264 33.474 26.241h-.115l44.852-35.531-.042.091c-.194-6.444-.4-13.2-.6-20.083l-.41-13.693.114.11-90 1.024.072-.073.082 23.619.013 6.3v1.627c0 .369-.007.555-.007.555s-.007-.183-.012-.546-.01-.908-.017-1.619l-.05-6.292-.154-23.644v-.069h.073l90-1.1h.111v.111l.412 13.693c.206 6.879.409 13.639.6 20.082v.057l-.044.035-44.876 35.5-.058.046-.058-.045-33.448-26.329-9.247-7.3-2.418-1.916c-.546-.434-.82-.662-.82-.662z",
  className: "cls-5",
  transform: "translate(-285.577 -147.292)"
}))))));

var _ref24 = /*#__PURE__*/React.createElement("g", {
  id: "Group_2564",
  transform: "translate(5.797 11.257)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2563"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2562"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2561",
  opacity: 0.8
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1432",
  fill: "#fff",
  d: "M285.906 180.72l-.16-32.1 90-1.064 1.014 33.776-44.86 35.514z",
  transform: "translate(-285.745 -147.554)"
})))));

var _ref25 = /*#__PURE__*/React.createElement("g", {
  id: "Group_2569",
  transform: "translate(20.092 27.388)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2568"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1433",
  d: "M380.031 184.6c0 .063-13.763.2-30.738.3s-30.742.136-30.743.073 13.76-.2 30.741-.3 30.74-.131 30.74-.073z",
  className: "cls-5",
  transform: "translate(-318.55 -184.572)"
})));

var _ref26 = /*#__PURE__*/React.createElement("g", {
  id: "Group_2571",
  transform: "translate(20.092 36.456)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2570"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1434",
  d: "M380.031 205.413c0 .063-13.763.2-30.738.3s-30.742.135-30.743.073 13.76-.2 30.741-.3 30.74-.136 30.74-.073z",
  className: "cls-5",
  transform: "translate(-318.55 -205.381)"
})));

var _ref27 = /*#__PURE__*/React.createElement("g", {
  id: "Group_2573",
  transform: "translate(20.092 46.907)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2572"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1435",
  d: "M380.031 229.4c0 .063-13.763.2-30.738.3s-30.742.136-30.743.073 13.76-.2 30.741-.3 30.74-.139 30.74-.073z",
  className: "cls-5",
  transform: "translate(-318.55 -229.365)"
})));

var _ref28 = /*#__PURE__*/React.createElement("g", {
  id: "Group_2575",
  transform: "translate(22.918 57.357)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2574"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1436",
  d: "M383.69 253.378c0 .063-13.131.193-29.326.292s-29.329.127-29.33.064 13.128-.193 29.328-.292 29.328-.126 29.328-.064z",
  className: "cls-5",
  transform: "translate(-325.035 -253.345)"
})));

var _ref29 = /*#__PURE__*/React.createElement("g", {
  id: "Group_2577",
  transform: "translate(34.575 66.519)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2576"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1437",
  d: "M387.273 274.415a2.116 2.116 0 0 1-.36.025l-1.034.028-3.8.063-12.544.18c-4.9.082-9.337.11-12.549.113l-3.8-.009-1.034-.014a2.178 2.178 0 0 1-.36-.021 2.118 2.118 0 0 1 .36-.025l1.034-.028 3.8-.063 12.546-.18c4.9-.082 9.335-.109 12.546-.113l3.8.01 1.034.014a2.129 2.129 0 0 1 .361.02z",
  className: "cls-5",
  transform: "translate(-351.787 -274.371)"
})));

var _ref30 = /*#__PURE__*/React.createElement("g", {
  id: "Group_2579",
  transform: "translate(45.367 75.267)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2578"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1438",
  d: "M389.661 294.561c0 .063-2.935.113-6.554.113s-6.555-.051-6.555-.113 2.934-.114 6.555-.114 6.554.053 6.554.114z",
  className: "cls-5",
  transform: "translate(-376.553 -294.447)"
})));

var _ref31 = /*#__PURE__*/React.createElement("g", {
  id: "Group_2580",
  transform: "translate(77.898 46.518)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_152",
  cx: 10.871,
  cy: 10.871,
  r: 10.871,
  className: "cls-6"
}));

var _ref32 = /*#__PURE__*/React.createElement("g", {
  id: "Group_2581",
  transform: "translate(75.068 46.518)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_153",
  cx: 10.871,
  cy: 10.871,
  r: 10.871,
  fill: "#4d4d4d"
}));

var _ref33 = /*#__PURE__*/React.createElement("g", {
  id: "Group_2582",
  transform: "translate(83.732 52.328)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1439",
  fill: "#ebebeb",
  d: "M468.184 241.806v9.038h-1.679v-7.631h-1.911v-1.407z",
  transform: "translate(-464.594 -241.806)"
}));

var _ref34 = /*#__PURE__*/React.createElement("g", {
  id: "Group_2592",
  transform: "translate(167.771 71.845)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2587",
  transform: "translate(10.351 9.02)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2584",
  transform: "translate(0 1.506)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1440",
  d: "M287.731 104.868h9.942l-1.344-1.545v-3.7A3.623 3.623 0 0 0 292.7 96a3.623 3.623 0 0 0-3.622 3.624v3.52z",
  className: "cls-3",
  transform: "translate(-287.731 -95.999)"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_2585",
  transform: "translate(3.582 9.37)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1441",
  d: "M295.95 114.562a1.536 1.536 0 1 0 3-.516",
  className: "cls-3",
  transform: "translate(-295.95 -114.046)"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_2586",
  transform: "translate(4.549)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Rectangle_613",
  fill: "#e8505b",
  d: "M0 0H0.975V2.073H0z"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_2591"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2590"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2589"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2588"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1442",
  d: "M293.8 84.434a1.793 1.793 0 0 1-.07-.261l-.174-.767a9.234 9.234 0 0 0-.353-1.226c-.085-.237-.146-.5-.266-.768l-.37-.847a15.052 15.052 0 0 0-2.635-3.895 14.672 14.672 0 0 0-14.132-4.133c-.33.07-.648.2-.977.293a6.835 6.835 0 0 0-.973.356 13.918 13.918 0 0 0-3.687 2.207 14.641 14.641 0 0 0-4.922 7.874 14.287 14.287 0 0 0-.285 5.057 14.021 14.021 0 0 0 1.493 5l.253.474.033.063-.02.064-2.354 7.727-.207-.187 6.225-3.246.077-.04.07.054a14.65 14.65 0 0 0 6.554 2.847 14.556 14.556 0 0 0 11.53-3.164 15 15 0 0 0 3.276-3.833 14.516 14.516 0 0 0 2.024-6.983q0-.645.007-1.146l-.073-.834-.041-.511a.91.91 0 0 1-.006-.174.954.954 0 0 1 .03.171l.065.509.1.835.015 1.153a15.936 15.936 0 0 1-.392 3.155 16.109 16.109 0 0 1-1.571 3.923 15.106 15.106 0 0 1-3.293 3.908 14.737 14.737 0 0 1-11.7 3.265 14.888 14.888 0 0 1-6.684-2.883l.147.014-6.22 3.256-.314.164.107-.351 2.35-7.729.014.127-.258-.484a14.326 14.326 0 0 1-1.525-5.113 14.58 14.58 0 0 1 .3-5.169A14.9 14.9 0 0 1 270 75.165a14.136 14.136 0 0 1 3.76-2.235 6.981 6.981 0 0 1 .99-.358c.334-.1.658-.225.994-.295a14.677 14.677 0 0 1 16.928 8.237l.361.86c.117.268.174.538.255.778a8.623 8.623 0 0 1 .327 1.24l.146.776a1.882 1.882 0 0 1 .039.266z",
  className: "cls-8",
  transform: "translate(-263.978 -71.845)"
}))))));

var _ref35 = /*#__PURE__*/React.createElement("g", {
  id: "Group_2595",
  transform: "translate(304.576 187.915)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2594"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2593"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1443",
  d: "M591.166 338.209c1.423 4.817.343 11.006-1.382 15.723a23.826 23.826 0 0 1-9.192 11.62c-.473.312-1.079.613-1.577.344a1.61 1.61 0 0 1-.639-1.184 24.54 24.54 0 0 1 12.79-26.5",
  className: "cls-3",
  transform: "translate(-577.926 -338.209)"
}))));

var _ref36 = /*#__PURE__*/React.createElement("g", {
  id: "Group_2598",
  transform: "translate(304.576 187.915)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2597"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2596"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1444",
  d: "M591.166 338.209c1.423 4.817.343 11.006-1.382 15.723a23.826 23.826 0 0 1-9.192 11.62c-.473.312-1.079.613-1.577.344a1.61 1.61 0 0 1-.639-1.184 24.54 24.54 0 0 1 12.79-26.5",
  className: "cls-3",
  transform: "translate(-577.926 -338.209)"
}))));

var _ref37 = /*#__PURE__*/React.createElement("g", {
  id: "Group_2601",
  opacity: 0.2,
  transform: "translate(304.576 187.915)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2600"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2599"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1445",
  d: "M591.166 338.209c1.423 4.817.343 11.006-1.382 15.723a23.826 23.826 0 0 1-9.192 11.62c-.473.312-1.079.613-1.577.344a1.61 1.61 0 0 1-.639-1.184 24.54 24.54 0 0 1 12.79-26.5",
  transform: "translate(-577.926 -338.209)"
}))));

var _ref38 = /*#__PURE__*/React.createElement("g", {
  id: "Group_2620",
  transform: "translate(287.884 165.059)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2614"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2613"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2604"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2603"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2602"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1446",
  d: "M548.148 285.758c3-.082 4.979 3.251 5.279 6.238s-.365 6.088.512 8.959c1.114 3.646 4.522 6.262 5.555 9.932 1.218 4.328-1.156 8.819-1.27 13.314-.055 2.187.428 4.4.023 6.546a8.048 8.048 0 0 1-15.788.157c-.7-3.367.781-6.944-.108-10.266-.658-2.456-2.564-4.541-2.719-7.078-.185-3.019 2.152-5.63 2.585-8.624s-1.078-5.918-1.3-8.936c-.4-5.413 1.837-9.663 7.234-10.242",
  className: "cls-3",
  transform: "translate(-539.621 -285.757)"
})))), /*#__PURE__*/React.createElement("g", {
  id: "Group_2608",
  transform: "translate(15.097 32.895)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2607"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2606"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2605"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1447",
  d: "M574.269 389.991a1.3 1.3 0 0 0 .088-.3l.2-.87c.163-.757.413-1.85.741-3.2a103.784 103.784 0 0 1 7.248-20.346c.6-1.25 1.093-2.255 1.447-2.944l.4-.8a1.325 1.325 0 0 0 .121-.288 1.266 1.266 0 0 0-.172.261l-.444.775c-.383.675-.909 1.667-1.53 2.908a90.7 90.7 0 0 0-7.263 20.387c-.3 1.354-.525 2.455-.654 3.221l-.146.881a1.3 1.3 0 0 0-.036.315z",
  className: "cls-5",
  transform: "translate(-574.265 -361.247)"
}))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_2612",
  transform: "translate(8.648 14.763)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2611"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2610"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2609"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1448",
  d: "M559.471 319.636a2.973 2.973 0 0 0 .04.481l.169 1.37.663 5.032c.565 4.247 1.339 10.116 2.154 16.6s1.516 12.367 2.02 16.622c.252 2.108.457 3.822.6 5.039l.175 1.369a3.039 3.039 0 0 0 .08.475 3.134 3.134 0 0 0-.023-.482l-.122-1.374-.512-5.05c-.453-4.262-1.123-10.145-1.938-16.635s-1.621-12.354-2.237-16.6l-.753-5.019-.221-1.362a3.074 3.074 0 0 0-.095-.466z",
  className: "cls-5",
  transform: "translate(-559.468 -319.636)"
}))))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_2619",
  transform: "translate(2.794 55.753)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2615"
}, /*#__PURE__*/React.createElement("path", {
  id: "Rectangle_614",
  d: "M0 0H22.771V2.659H0z",
  className: "cls-5"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_2616",
  transform: "translate(2.111 2.659)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1449",
  d: "M550.877 419.8l2.674 16.131h14.125l1.851-16.131z",
  className: "cls-6",
  transform: "translate(-550.877 -419.804)"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_2618",
  transform: "translate(2.041 2.504)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2617"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1450",
  d: "M569.508 419.494c0 .062-4.206.166-9.394.23s-9.4.066-9.4 0 4.2-.166 9.395-.23 9.399-.063 9.399 0z",
  className: "cls-12",
  transform: "translate(-550.716 -419.448)"
})))));

function SvgMailverify(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 249.999,
    height: 174.56,
    viewBox: "0 0 249.999 174.56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, /*#__PURE__*/React.createElement("g", {
    id: "Group_2621",
    transform: "translate(-93.47 -71.845)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "_Path_",
    cx: 124.999,
    cy: 7.3,
    rx: 124.999,
    ry: 7.3,
    transform: "translate(93.47 231.805)",
    style: {
      isolation: "isolate"
    },
    fill: "#f4f4f4",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2533",
    transform: "translate(97.388 88.759)"
  }, _ref3, _ref4, _ref5, /*#__PURE__*/React.createElement("g", {
    id: "Group_2520",
    transform: "translate(26.433)"
  }, _ref6, /*#__PURE__*/React.createElement("g", {
    id: "Group_2519",
    transform: "translate(10.037)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2517",
    transform: "translate(.553 3.975)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2516"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2515"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2506"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2505"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2504"
  }, _ref7, _ref8, _ref9, _ref10, /*#__PURE__*/React.createElement("g", {
    id: "Group_2494",
    transform: "translate(5.009 16.145)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2493"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2492"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2491"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1412",
    d: "M204.7 158.375a10.982 10.982 0 0 1-5.782-1.542s1.4 2.965 5.724 2.561z",
    transform: "translate(-198.917 -156.833)",
    style: {
      isolation: "isolate"
    },
    opacity: 0.2
  }))))), _ref11, _ref12))), _ref13, _ref14))), _ref15)), _ref16), /*#__PURE__*/React.createElement("g", {
    id: "Group_2583",
    transform: "translate(171.459 93.579)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2567"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2566"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2565"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2554"
  }, _ref17, _ref18, /*#__PURE__*/React.createElement("g", {
    id: "Group_2542",
    transform: "translate(.781)",
    style: {
      isolation: "isolate"
    },
    opacity: 0.3
  }, _ref19), _ref20, _ref21, _ref22), _ref23, _ref24))), _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33), _ref34, _ref35, _ref36, _ref37, _ref38));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailverify);
export default __webpack_public_path__ + "static/media/mailverify.051cc40a.svg";
export { ForwardRef as ReactComponent };